import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import dayjs from 'dayjs';
import dayjsEn from 'dayjs/locale/en';
import dayjsZh from 'dayjs/locale/zh-cn';
import zh from './zh-ch';
import en from './en';

// 国际化缩写 https://www.jianshu.com/p/99acd1bad729

import { formatMoney, formatOrdinalNumber, formatUserType } from './formatter';

function i18nInit(lang: string) {
  // dayjs国际化
  dayjs.locale(lang, lang === 'en' ? dayjsEn : dayjsZh);

  return i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(intervalPlural)
    .init({
      // ns: ['common'],
      // defaultNS: 'common',

      // https://www.i18next.com/how-to/add-or-load-translations
      resources: {
        en,
        zh,
      },

      // debug: true,
      lng: lang,
      fallbackLng: ['zh', 'en'], // use en if detected lng is not available

      keySeparator: false, // we do not use keys in form messages.welcome

      interpolation: {
        escapeValue: false, // react already safes from xss

        // 占位符格式化入口
        format(value, format, lng) {
          switch (format) {
            case 'formatMoney':
              return formatMoney(value, lng);
            case 'ordinalNumber':
              return formatOrdinalNumber(value, lng);
            case 'formatUserType':
              return formatUserType(value, lng);
            default:
              return value;
          }
        },
      },
    });
}

// 马上初始化i18n，避免其他模块调用时获取不到配置
i18nInit('en');
